// import React from "react";
// import { Helmet } from "react-helmet";
// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
// import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
// import HttpAPICall from "../../../services/HttpAPICall";
// import Loader from "../../../components/ui/Loader/Loader";
// import TapIcon from "../../../services/TapIcon";
// import ItemWhConfigModel from "./ItemWhConfigModel";

// class ItemWhConfig extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state              =   {
//             itemId                 :   null,
//             refreshDetail           :   false,
//             configList              :   [],
//             listing_loading         :   false,
//         };
//         this.inventoryUrl           =   INVENTORY_API_BASE_URL_2 + '/item_config/list';

//         this.addConfigModelRef      =   React.createRef();
//     }

//     componentDidMount() {
//         this.setState({
//             itemId: this.props.item_enc_id,
//             refreshDetail: this.props.refreshDetail,
//         });
//         this.getConfigListing(this.props.item_enc_id);
//     }


//     componentWillReceiveProps(nextProps) {
//         if(nextProps.item_enc_id !== this.props.item_enc_id){
//             this.getConfigListing(nextProps.item_enc_id);
//             this.setState({itemId : nextProps.item_enc_id,itemName : nextProps.itemName});
//         }
//     }
 
//     getConfigListing = (itemId=null) => {
//         this.setState({ listing_loading: true });
//         HttpAPICall.withAthorization('GET', this.inventoryUrl, this.props.access_token, { 'search_item_id': itemId }, {}, (resp) => {
//             this.setState({
//                 configList: resp.data.data,
//             });
//         }).then(() => this.setState({ listing_loading: false }));

//     }

//     changeTab = (key) => {
//         let ParamObject = new URLSearchParams(this.props.location.search);
//         let itemName, itemCategory;
//         if (ParamObject.get("item_name")) {
//             itemName = ParamObject.get("item_name");
//         }
//         if (ParamObject.get("item_category")) {
//             itemCategory = ParamObject.get("item_category");
//         }
//         let obj = { item_name: itemName, item_category: itemCategory };
//         this.props.history.push({
//             pathname: `/item_list/${key}/${this.state.itemId}`,
//             search: "?" + new URLSearchParams(obj).toString(),
//         });
//     };


//     updateItemWarehouseConfigInit           =   (wid = null)  =>  {
//         let itemWarehouseConfigData             =   this.state.configList.find(c => c.id == this.state.itemId);
//         if(itemWarehouseConfigData) {

//             let warehousesConfigs               =   itemWarehouseConfigData.warehouses;

//             if(wid) {
//                 warehousesConfigs               =   warehousesConfigs.filter(w => w.id == wid);
//             }


//             let itemWhConfigFormData            =   warehousesConfigs.map(w => {
//                                                         return {
//                                                             item_id             :   itemWarehouseConfigData.id,
//                                                             warehouse_id        :   w.id,
//                                                             warehouse_name      :   w.name,
//                                                             bin_location        :   w.item_config ? w.item_config.bin_location : null,
//                                                             max_inventory_level :   w.item_config ? w.item_config.max_inventory_level : null,
//                                                             min_inventory_level :   w.item_config ? w.item_config.min_inventory_level : null,
//                                                             re_order_level      :   w.item_config ? w.item_config.re_order_level      : null,
//                                                             replenishment_period:   w.item_config ? w.item_config.replenishment_period : null,
//                                                         };
//                                                     }); 
//             this.addConfigModelRef.current.addConfigInit(itemWhConfigFormData);
//         }
//     }


//     render() {
//         let itemCategory;
//         let showTabHeader =  true;
//         if(this.props.showTabHeader !== undefined || this.props.showTabHeader == false){
//             showTabHeader = false
//         }
       
//         if (this.props && this.props && this.props.location && this.props.location.search) {
//             let ParamObject = new URLSearchParams(this.props.location.search);

            
//             if (ParamObject.get("item_category")) {
//                 itemCategory = ParamObject.get("item_category");
//             }
//         }
       
//         return (
//             <section className="item_view_container bg-white">
               
//                 <div className="tab_content_header">
//                     <table className="table table-hover table-bordered table-responsive bg-white mt-3 mb-5">
//                         <thead className="table-secondary">
//                             <tr className="text-end">
//                                 <th style={{ width: "5%" }} className="text-center">
//                                     S.No
//                                 </th>
//                                 <th style={{ width: "30%" }} className="text-start">
//                                     Warehouse
//                                 </th>
//                                 <th style={{ width: "14%" }}>
//                                     Bin Location
//                                 </th>
//                                 <th style={{ width: "12%" }}>
//                                     Max Level
//                                 </th>
//                                 <th style={{ width: "12%" }}>
//                                     Min Level
//                                 </th>
//                                 <th style={{ width: "12%" }}>
//                                     Re-order Level
//                                 </th>
//                                 <th style={{ width: "10%" }}>
//                                     Replenishment Period
//                                 </th>
//                               {showTabHeader == true &&  <th style={{ width: "5%" }}>Action</th>}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {this.state.listing_loading
//                                 ?
//                                 <tr>
//                                     <td className="text-center" colSpan="8">
//                                         <Loader />
//                                     </td>
//                                 </tr>
//                                 :
//                                 this.state.configList.map((data, key) => {
//                                     return (
//                                         data.warehouses.map((whConfig, k) => {
//                                             return (
//                                               <tr key={k}>
//                                                 <td>{(k += 1)}</td>
//                                                 <td>
//                                                   <b>{whConfig.name}</b>
//                                                 </td>
//                                                 <td>
//                                                   {whConfig.item_config &&
//                                                     whConfig.item_config
//                                                       .bin_location}
//                                                 </td>
//                                                 <td className="text-end">
//                                                   {whConfig.item_config &&
//                                                     whConfig.item_config
//                                                       .max_inventory_level}
//                                                 </td>
//                                                 <td className="text-end">
//                                                   {whConfig.item_config &&
//                                                     whConfig.item_config
//                                                       .min_inventory_level}
//                                                 </td>
//                                                 <td className="text-end">
//                                                   {whConfig.item_config &&
//                                                     whConfig.item_config
//                                                       .re_order_level}
//                                                 </td>
//                                                 <td className="text-end">
//                                                   {whConfig.item_config &&
//                                                     whConfig.item_config
//                                                       .replenishment_period}
//                                                 </td>
//                                                {showTabHeader == true &&  <td>
//                                                   <TapIcon.imageIcon
//                                                     icon={
//                                                       TapIcon.ListActionIcon
//                                                     }
//                                                     alt="action-icon"
//                                                     className="img-fluid px-3"
//                                                     data-bs-toggle="dropdown"
//                                                     href="#"
//                                                     role="button"
//                                                     aria-expanded="false"
//                                                   />
//                                                   <ul
//                                                     className="dropdown-menu"
//                                                     aria-labelledby="dropdownMenuButton1"
//                                                   >
//                                                     <li>
//                                                       <button
//                                                         onClick={() =>
//                                                           this.updateItemWarehouseConfigInit(
//                                                             whConfig.id
//                                                           )
//                                                         }
//                                                         className={[
//                                                           "dropdown-item cursor_pointer",
//                                                         ]}
//                                                       >
//                                                         Update
//                                                       </button>
//                                                     </li>
//                                                   </ul>
//                                                 </td>}
//                                               </tr>
//                                             );
//                                         })
//                                     )
//                                 })
//                             }

//                         </tbody>
//                     </table>
//                 </div>
//                 <ItemWhConfigModel ref={this.addConfigModelRef} afterFormSubmit={() => this.getConfigListing(this.props.item_enc_id) } />
//             </section>
//         );
//     }
// }

// const mapStateToProps = (state) => {
//     return {
//         access_token: state.auth.access_token,
//         isc_configuration:
//             state.app && state.app.isc_configuration
//                 ? state.app.isc_configuration
//                 : null,
//     };
// };

// export default connect(mapStateToProps, null, null, { forwardRef: true })(ItemWhConfig);

import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import TapIcon from "../../../services/TapIcon";
import ItemWhConfigModel from "./ItemWhConfigModel";

class ItemWhConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemId: null,
            refreshDetail: false,
            configList: [],
            listing_loading: false,
        };
        this.inventoryUrl = INVENTORY_API_BASE_URL_2 + '/item_config/list';
        this.addConfigModelRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.item_enc_id) {
            this.setState({ itemId: this.props.item_enc_id });
            this.getConfigListing(this.props.item_enc_id);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item_enc_id !== this.props.item_enc_id) {
            this.setState({ itemId: this.props.item_enc_id });
            this.getConfigListing(this.props.item_enc_id);
        }
    }

    getConfigListing = (itemId = null) => {
        if (!itemId) return;
        
        this.setState({ listing_loading: true });
        HttpAPICall.withAthorization('GET', this.inventoryUrl, this.props.access_token, 
            { 'search_item_id': itemId }, {}, (resp) => {
                this.setState({ configList: resp.data.data || [] });
            }).finally(() => this.setState({ listing_loading: false }));
    }

    updateItemWarehouseConfigInit = (wid = null) => {
        let itemWarehouseConfigData = this.state.configList.find(c => c.id == this.state.itemId);
        
        if (itemWarehouseConfigData && itemWarehouseConfigData.warehouses) {
            let warehousesConfigs = itemWarehouseConfigData.warehouses;

            if (wid) {
                warehousesConfigs = warehousesConfigs.filter(w => w.id == wid);
            }

            let itemWhConfigFormData = warehousesConfigs.map(w => {
                return {
                    item_id: itemWarehouseConfigData.id,
                    warehouse_id: w.id,
                    warehouse_name: w.name,
                    bin_location: w.item_config ? w.item_config.bin_location : null,
                    max_inventory_level: w.item_config ? w.item_config.max_inventory_level : null,
                    min_inventory_level: w.item_config ? w.item_config.min_inventory_level : null,
                    re_order_level: w.item_config ? w.item_config.re_order_level : null,
                    replenishment_period: w.item_config ? w.item_config.replenishment_period : null,
                };
            });
            
            if (this.addConfigModelRef.current) {
                this.addConfigModelRef.current.addConfigInit(itemWhConfigFormData);
            }
        }
    }

    render() {
        let showTabHeader = this.props.showTabHeader !== false;
       
        return (
            <section className="item_view_container bg-white">
                {/* Add button at the top */}
                {/* <div className="tab_content_header d-flex justify-content-end mb-2">
                    <button
                        onClick={() => this.updateItemWarehouseConfigInit()}
                        className="btn btn-primary btn-sm"
                        disabled={this.state.listing_loading || this.state.configList.length === 0}
                    >
                        <TapIcon.FontAwesomeIcon icon={TapIcon.faCog} className="me-1" />
                        Configure All Warehouses
                    </button>
                </div> */}
                 <div className="tab_content_header">
                 <div className="tab_content_wrapper"><span className="content_heading">Configuration</span>
                        <div className="float-end"><button className="btn btn-primary" disabled={this.state.listing_loading || this.state.configList.length === 0} onClick={() => this.updateItemWarehouseConfigInit()}>Configure All Warehouses </button></div>
                    </div>

               
                    <table className="table table-hover table-bordered table-responsive bg-white mt-3 mb-5">
                        <thead className="table-secondary">
                            <tr className="text-end">
                                <th style={{ width: "5%" }} className="text-center">S.No</th>
                                <th style={{ width: "30%" }} className="text-start">Warehouse</th>
                                <th style={{ width: "14%" }}>Bin Location</th>
                                <th style={{ width: "12%" }}>Min Level</th>
                                <th style={{ width: "12%" }}>Max Level</th>
                                <th style={{ width: "12%" }}>Re-order Level</th>
                                <th style={{ width: "10%" }}>Replenishment Period</th>
                                {showTabHeader && <th style={{ width: "5%" }}>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.listing_loading ? (
                                <tr>
                                    <td className="text-center" colSpan="8">
                                        <Loader />
                                    </td>
                                </tr>
                            ) : this.state.configList.length > 0 ? (
                                this.state.configList.map((data) => 
                                    data.warehouses && data.warehouses.map((whConfig, k) => (
                                        <tr key={k}>
                                            <td>{k + 1}</td>
                                            <td><b>{whConfig.name}</b></td>
                                            <td>{whConfig.item_config?.bin_location || '-'}</td>
                                            <td className="text-end">{whConfig.item_config?.min_inventory_level || '-'}</td>
                                            <td className="text-end">{whConfig.item_config?.max_inventory_level || '-'}</td>
                                            <td className="text-end">{whConfig.item_config?.re_order_level || '-'}</td>
                                            <td className="text-end">{whConfig.item_config?.replenishment_period || '-'}</td>
                                            {showTabHeader && (
                                                <td>
                                                    <TapIcon.imageIcon
                                                        icon={TapIcon.ListActionIcon}
                                                        alt="action-icon"
                                                        className="img-fluid px-3"
                                                        data-bs-toggle="dropdown"
                                                        role="button"
                                                    />
                                                    <ul className="dropdown-menu">
                                                        <li>
                                                            <button
                                                                onClick={() => this.updateItemWarehouseConfigInit(whConfig.id)}
                                                                className="dropdown-item cursor_pointer"
                                                            >
                                                                Update
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">No configurations found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <ItemWhConfigModel 
                    ref={this.addConfigModelRef} 
                    afterFormSubmit={() => this.getConfigListing(this.props.item_enc_id)} 
                />
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    access_token: state.auth.access_token,
    isc_configuration: state.app?.isc_configuration || null,
});

export default connect(mapStateToProps)(ItemWhConfig);